<template>
    <i :class="['uil', `uil-${name}`]" />
</template>

<script>
export default {
    name: 'EditorIcon',

    props: {
        name: {
            type: String,
            required: true,
        },
    },
};
</script>
